export var AuthMethodType;
(function (AuthMethodType) {
    AuthMethodType[AuthMethodType["SAML"] = 0] = "SAML";
})(AuthMethodType || (AuthMethodType = {}));
//# sourceMappingURL=auth-method-type.enum.js.map